// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12GwU","option":"styles_option__1n6uB","active":"styles_active__2AR9X"};